import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import {Concept} from 'types';
import type {ViewMode} from 'api/types';
import type {RootState} from 'store/types';
import type {AdvancedSearchViewModeState} from './types';

const initialState: AdvancedSearchViewModeState =
  Concept.manifestation as ViewMode;

const advancedSearchViewModeSlice = createSlice({
  name: 'advancedSearchViewMode',
  initialState,
  reducers: {
    advancedSearchViewModeUpdated: (
      _state,
      action: PayloadAction<AdvancedSearchViewModeState>,
    ) => {
      return action.payload;
    },
    advancedSearchViewModeCleared: () => {
      return initialState;
    },
  },
});

export const {advancedSearchViewModeUpdated, advancedSearchViewModeCleared} =
  advancedSearchViewModeSlice.actions;
export const selectAdvancedSearchViewMode = (state: RootState) =>
  state.advancedSearchViewMode;

export default advancedSearchViewModeSlice;
